import { useTranslation } from "react-i18next";
import { Heading } from "components/designV2/heading/heading";
import {
  PageHeaderRow,
  PageLayout,
} from "components/designV2/layout/pageLayout";
import { OrganizationalStructureOverview } from "./organizationalStructureOverview.component";
import { useOrganizationalStructureStore } from "web-apps/company/stores/organizationalStructureStore/organizationalStructureStore";
import { CreateWorkerModal } from "./createWorkerModal.component";
import { useState } from "react";
import { EmptyStructure } from "./emptyStructure.component";

export const OrganizationalStructure = () => {
  const { t } = useTranslation();
  const [state] = useOrganizationalStructureStore();
  const [showCreateModal, setShowCreateModal] = useState(false);

  return (
    <PageLayout>
      <PageHeaderRow>
        <Heading level="h2">
          {t("OrganizationalStructure.Organization")}
        </Heading>
      </PageHeaderRow>
      {!state.structure ? (
        <EmptyStructure type={"Entity"} />
      ) : (
        <OrganizationalStructureOverview entities={state.structure.entities} />
      )}
      <CreateWorkerModal
        showCreateModal={showCreateModal}
        setShowCreateModal={setShowCreateModal}
      />
    </PageLayout>
  );
};
